import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { scrollToId } from '../../utils/scroll';
import { pillars } from '../../data/whatYouGet';
import { interiorPreviewItems } from '../../data/interiorPreview';
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-272" data-mp="1e0bksqyd4npw">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-273" data-mp="1dyqr13jvh8t3">
        <SectionTag icon="🎁" data-id="element-274" data-mp="190guopmew25w">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-275" data-mp="1nqwdjxrcuy0w">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-276" data-mp="1itnyi61i7a3v">
          Sesiones listas para que preparar tus entrenamientos deje de quitarte horas.
        </p>
        <p className="mt-2 text-sm font-medium text-naranja" data-id="element-277" data-mp="1rtt1m3znzmc8">
          6 tomos + 5 bonos · 11 PDF · 414 páginas
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-278" data-mp="2zxf0vdrepkbj">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border-2 border-naranja bg-white p-6 shadow-card sm:p-7" data-id="element-279" data-mp="34vqbhqpizyut" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-280" data-mp="3nn9bdoo96wsm">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-azul-light" data-id="element-281" data-mp="3no17r1pocyjy">
                <pillar.icon size={22} className="text-azul" data-id="element-282" data-mp="3so6ty2d6dsun" />
              </div>
              <span className="rounded-full bg-verde-light px-3 py-1 text-xs font-semibold text-verde" data-id="element-283" data-mp="1hvxkjj41g9n">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-azul-dark sm:text-xl" data-id="element-284" data-mp="22jbyg8sls51d">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-285" data-mp="2baklwod4dzl2">
              <span className="text-rojo line-through" data-id="element-286" data-mp="2bbvowlyqr3b4">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-287" data-mp="26j2na6ykkb39">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-288" data-mp="2l7gvyyio2trq">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-289" data-mp="2gagtsyoxub5w">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-gris-oscuro" data-id="element-290" data-mp="2u9q6vphukp5n">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-291" data-mp="2q8wlb2rvnmfx" />
                  <span data-id="element-292" data-mp="zunmg67nnx9l">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>

      <div className="mx-auto mt-12 max-w-5xl px-4 sm:px-6" data-id="element-293" data-mp="vveriy0vptcg">
        <div className="text-center" data-id="element-294" data-mp="lpdkmp0anbfj">
          <SectionTag icon="👀" data-id="element-295" data-mp="lqf5tmb0xeaz">Vistazo al interior</SectionTag>
          <h3 className="mx-auto mt-4 max-w-2xl font-heading text-2xl font-bold uppercase leading-tight text-azul sm:text-3xl" data-id="element-296" data-mp="prqnn5nnov8m">
            Mira cómo vas a preparar tu próximo entrenamiento
          </h3>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-297" data-mp="gydlre7m6jae">
            Estas son páginas reales de los PDF que recibes: una sesión completa en dos páginas, técnica
            ilustrada, rotaciones y herramientas para organizar y seguir el trabajo del equipo.
          </p>
        </div>

        <div className="mt-8" data-id="element-298" data-mp="3p86sqmaaz82b">
          <p className="mb-2 text-center text-xs font-medium text-muted" data-id="element-299" data-mp="3p8yqo3rdhhvr">← Desliza para ver todas las páginas →</p>
          <div className="scrollbar-hide flex snap-x snap-mandatory gap-6 overflow-x-auto pb-2" data-id="element-300" data-mp="1nfin66a6s8jd">
            {interiorPreviewItems.map((item, i) => <m.figure key={item.src} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i % 3 * 0.08
          }} className="flex w-[80%] flex-shrink-0 snap-center flex-col overflow-hidden rounded-2xl border border-gris-claro bg-white shadow-card sm:w-[45%] lg:w-[31%]" data-id="element-301" data-mp="1sdtyklg4qr3p" data-mpi={i}>
                <img src={item.src} alt={`${item.title} — ${item.origin}`} loading="lazy" decoding="async" className="w-full object-contain" data-id="element-302" data-mp="35j4i5qdul1wx" />
                <figcaption className="flex flex-1 flex-col gap-2 p-5 text-left" data-id="element-303" data-mp="2vt2tawdo7fgy">
                  {item.badge && <span className="inline-block w-fit rounded-full bg-azul-light px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-azul" data-id="element-304" data-mp="2qrvj6qo22474">
                      {item.badge}
                    </span>}
                  <h4 className="font-heading text-base font-semibold text-azul-dark" data-id="element-305" data-mp="xbsjxrp0l2gz">{item.title}</h4>
                  <p className="text-sm leading-relaxed text-muted" data-id="element-306" data-mp="129au1lerpnqk">{item.text}</p>
                  <p className="mt-auto pt-1 text-xs text-gris-medio" data-id="element-307" data-mp="16b5xowk68d7i">{item.origin}</p>
                </figcaption>
              </m.figure>)}
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-sm leading-relaxed text-muted" data-id="element-308" data-mp="ekhz9s9vtlxj">
          Elige el objetivo. Consulta el montaje y las correcciones. Ajusta la dificultad y lleva la sesión
          a la pista.
        </p>
        <div className="mt-5 flex justify-center" data-id="element-309" data-mp="nk4ziaqvklp0">
          <PrimaryButton size="md" onClick={() => scrollToId('oferta-base')} data-id="element-310" data-mp="njd1kt9t2bvk">
            Quiero entrenar así
          </PrimaryButton>
        </div>
      </div>
    </section>;
}